const locale = {
	// #region Tabs
	TAB_GENERAL: 'Generali',
	TAB_TRANSLATIONS: 'Traduzioni',
	TAB_CLOSINGDAYS: 'Giorni di chiusura',
	TAB_INTEGRATIONS: 'Connettori',
	TAB_JASPERREPORTS: 'Jasper Reports',
	TAB_CARBONE: 'Carbone',
	// #endregion

	// #region General settings tab
	DETAILS_SETTINGS_MAIN_SECTION: 'Impostazioni',
	DETAILS_SETTINGS_MAIN_SUBHEADER: "Impostazioni base dell'applicazione",
	SETTINGS_SELF_VATNUMBER: 'Partita IVA autofattura',
	SETTINGS_WORKDAY_TIME_START: 'Ora inizio giornata lavorativa',
	SETTINGS_WORKDAY_TIME_END: 'Ora fine giornata lavorativa',
	SETTINGS_TIME_MINIMUM_INTERVAL: 'Intervallo minimo orari',
	SETTINGS_ACTIVITIES_EXPIRING_TIER1: 'Attività - Scadenza tier 1',
	SETTINGS_ACTIVITIES_EXPIRING_TIER2: 'Attività - Scadenza tier 2',
	SETTINGS_OPPORTUNITIES_EXPIRING_TIER1: 'Opportunità - Scadenza tier 1',
	SETTINGS_OPPORTUNITIES_EXPIRING_TIER2: 'Opportunità - Scadenza tier 2',

	DETAILS_SETTINGS_FILES_SECTION: 'Impostazioni file',
	DETAILS_SETTINGS_FILES_SUBHEADER: "Impostazioni dei file gestiti dall'applicazione",
	SETTINGS_FILES_PATH: 'Percorso cartella file',
	SETTINGS_DOCS_PATH: 'Percorso cartella documenti generica',
	SETTINGS_DOCS_CUSTOMERS_PATH: 'Percorso cartella documenti Aziende Clienti',
	SETTINGS_DOCS_SUPPLIERS_PATH: 'Percorso cartella documenti Aziende Fornitori',
	SETTINGS_DOCS_ORDERS_PATH: 'Percorso cartella documenti Ordini',
	SETTINGS_DOCS_PROJECTS_PATH: 'Percorso cartella documenti Progetti',
	SETTINGS_DOCS_MARKETINGACTIONS_PATH: 'Percorso cartella documenti Azioni di Marketing',
	SETTINGS_DOCS_COMMERCIALCAMPAIGNS_PATH: 'Percorso cartella documenti Campagne Commerciali',
	SETTINGS_DOCS_OTHERS_PATH: 'Percorso cartella documenti Aziende Altro',
	SETTINGS_DOCS_COMPANIES_ENABLED: 'Abilita la gestione dei documenti delle Aziende',
	SETTINGS_DOCS_ORDERS_ENABLED: 'Abilita la gestione dei documenti degli Ordini',
	SETTINGS_DOCS_PROJECTS_ENABLED: 'Abilita la gestione dei documenti dei Progetti',
	SETTINGS_DOCS_MARKETINGACTIONS_ENABLED: 'Abilita la gestione dei documenti delle Azioni di Marketing',
	SETTINGS_DOCS_COMMERCIALCAMPAIGNS_ENABLED: 'Abilita la gestione dei documenti delle Campagne Commerciali',

	DETAILS_SETTINGS_FILES_RESERVED_SECTION: 'Impostazioni file riservati',
	DETAILS_SETTINGS_FILES_RESERVED_SUBHEADER: "Impostazioni dei file riservati gestiti dall'applicazione",
	SETTINGS_DOCS_CUSTOMERS_PATH_RESERVED: 'Percorso cartella documenti Clienti riservati',
	SETTINGS_DOCS_SUPPLIERS_PATH_RESERVED: 'Percorso cartella documenti Fornitori riservati',

	DETAILS_SETTINGS_ORDERS_SECTION: 'Impostazioni Ordini',
	DETAILS_SETTINGS_ORDERS_SUBHEADER: 'Impostazioni che modificano il funzionamento del modulo Ordini',
	SETTINGS_ORDERS_SHIPPING_ENABLED: 'Abilita il modulo Spedizioni',
	SETTINGS_ORDERS_LINES_ITEMS_GROUPED: "Aggrega le Righe d'Ordine con lo stesso Prodotto",
	SETTINGS_ORDERS_PRICE_CUSTOM_ENABLED: "Abilita la modifica completa delle Righe d'Ordine",
	SETTINGS_ORDERS_EXPENSES_MANAGER_ENABLED: "Abilita la gestione dei costi previsti nelle Righe d'Ordine",
	SETTINGS_ORDERS_LINES_WORKREPORTS_ENABLED: 'Abilita l\'aggiunta di Righe d\'Ordine di tipo "Servizio"',
	SETTINGS_ORDERS_LINES_PROJECTS_ENABLED: "Abilita la creazione di Progetti collegati a Righe d'Ordine",
	SETTINGS_ORDERS_LINES_INVOICES_ENABLED: "Abilita la creazione di Fatture collegate a Righe d'Ordine",
	SETTINGS_ORDERS_LINES_STATUS_ENABLED: "Abilita la gestione dello Stato d'Ordine per ogni Riga d'Ordine",
	SETTINGS_ORDERS_EXPIRED_IN_DAYS: 'Periodo validità',
	SETTINGS_ORDERS_MIN_ORDER_VALUE: "Minimo d'Ordine",

	SETTINGS_PROJECTS_FINANCIAL_STATS_ENABLED:
		'Abilita la visualizzazione delle statistiche finanziarie nei dettagli dei Progetti',

	DETAILS_SETTINGS_INVOICES_SECTION: 'Impostazioni Fatture',
	DETAILS_SETTINGS_INVOICES_SUBHEADER: 'Impostazioni che modificano il funzionamento del modulo Fatture',
	SETTINGS_INVOICES_ROWS_LINK_LINES_ENABLED:
		'Abilita la possibilità di collegare le righe dei Contratti/Ordini alle Righe delle Fatture',

	SETTINGS_B2B_MIN_ORDER_VALUE: "Minimo d'Ordine",
	DETAILS_SETTINGS_B2B_MERCHANDISE_SECTION: 'Merchandise B2B',
	DETAILS_SETTINGS_B2B_MERCHANDISE_SUBHEADER: 'Impostazioni del Merchandise B2B',
	SETTINGS_B2B_MERCHPOINTS_RATIO: 'Rateo conversione punti Merchandise',
	// #endregion

	// #region Translations settings tab
	DETAILS_SETTINGS_TRANSLATIONS_RESOURCES_SECTION: 'Traduzioni',
	DETAILS_SETTINGS_TRANSLATIONS_RESOURCES_SUBHEADER: 'Lista delle risorse usate per la localizzazione',
	I18N_TABLE_COLUMN_LANGUAGE: 'Lingua',
	I18N_TABLE_COLUMN_KEY: 'Chiave',
	I18N_TABLE_COLUMN_MESSAGE: 'Messaggio',
	// #endregion

	// #region Connectors settings tab
	DETAILS_SETTINGS_CREDITSAFE_SECTION: 'Creditsafe',
	DETAILS_SETTINGS_CREDITSAFE_SUBHEADER: "Impostazioni per l'integrazione con Creditsafe",
	SETTINGS_CREDITSAFE_USERNAME: 'Username',
	SETTINGS_CREDITSAFE_PASSWORD: 'Password',
	SETTINGS_CREDITSAFE_TEMPLATE: 'Tipo template',
	SETTINGS_CREDITSAFE_CREDITS: 'Crediti usati: {value}/{total}',

	DETAILS_SETTINGS_ATOKA_SECTION: 'Atoka',
	SETTINGS_ATOKA_TOKEN: 'Token',

	DETAILS_SETTINGS_GEOAPIFY_SECTION: 'Geoapify',
	SETTINGS_GEOAPIFY_REST_URL: 'Url REST',
	SETTINGS_GEOAPIFY_API_KEY: 'Api key',

	DETAILS_SETTINGS_HEREAPI_SECTION: 'HERE',
	SETTINGS_HERE_REST_URL: 'Url REST',
	SETTINGS_HERE_API_KEY: 'Api key',

	DETAILS_SETTINGS_MAILING_MAILCHIMP_SECTION: 'MailChimp',
	SETTINGS_MAILCHIMP_OAUTH_BUTTON: 'Collega account',
	SETTINGS_MAILCHIMP_CLIENT_ID: 'Client ID',
	SETTINGS_MAILCHIMP_CLIENT_SECRET: 'Client secret',
	// SETTINGS_MAILCHIMP_API_KEY: 'Chiave API',
	SETTINGS_MAILCHIMP_REST_URL: 'URL REST',
	SETTINGS_MAILCHIMP_PERMISSION_REMINDER: 'Permission reminder',
	SETTINGS_MAILCHIMP_LIST_LIMIT: 'Limite liste',
	SETTINGS_MAILCHIMP_NAME_LIMIT: 'Limite nomi',
	SETTINGS_MAILCHIMP_SENDER_NAME: 'Nome mittente predefinito',
	SETTINGS_MAILCHIMP_SENDER_MAIL: 'Mail mittente predefinita',
	SETTINGS_MAILCHIMP_SENDER_DEFAULT_LANGUAGE: 'Lingua messaggio predefinita',
	SETTINGS_TIME_WORKDAY: 'Ore giornaliere',

	DETAILS_SETTINGS_MAILING_MAILUP_SECTION: 'MailUp',
	SETTINGS_MAILUP_OAUTH_BUTTON: 'Collega account',
	SETTINGS_MAILUP_CLIENT_ID: 'Client ID',
	SETTINGS_MAILUP_CLIENT_SECRET: 'Client secret',
	SETTINGS_MAILUP_LIST: 'Lista',
	SETTINGS_MAILUP_SENDER_NAME: 'Nome mittente predefinito',
	SETTINGS_MAILUP_SENDER_MAIL: 'Mail mittente predefinita',

	DETAILS_SETTINGS_MICROSOFT365_SECTION: 'Microsoft Office 365',
	SETTINGS_MICROSOFT365_CLIENT_ID: 'Client ID',
	SETTINGS_MICROSOFT365_CLIENT_SECRET: 'Client secret',
	SETTINGS_MICROSOFT365_TENANT: 'Dominio',

	DETAILS_SETTINGS_POWERBI_SECTION: 'PowerBI',
	SETTINGS_POWERBI_REDIRECT_URI: 'Redirect URI',

	DETAILS_SETTINGS_EXCHANGEONLINE_SECTION: 'Exchange Online',
	SETTINGS_EXCHANGEONLINE_LINK_ACCOUNT: 'Collega account',
	SETTINGS_EXCHANGEONLINE_CHANGE_ACCOUNT: 'Cambia account',
	SETTINGS_EXCHANGEONLINE_REDIRECT_URI: 'Redirect URI',
	SETTINGS_EXCHANGEONLINE_MAIL_CUSTOMERS_FOLDER_IMPORT: 'ID cartella mail da importare Clienti',
	SETTINGS_EXCHANGEONLINE_MAIL_CUSTOMERS_FOLDER_IMPORTED: 'ID cartella mail importate Clienti',
	SETTINGS_EXCHANGEONLINE_MAIL_SUPPLIERS_FOLDER_IMPORT: 'ID cartella mail da importare Fornitori',
	SETTINGS_EXCHANGEONLINE_MAIL_SUPPLIERS_FOLDER_IMPORTED: 'ID cartella mail importate Fornitori',

	DETAILS_SETTINGS_BILLING_REVISO_SECTION: 'Reviso',
	SETTINGS_REVISO_APP_SECRET_TOKEN: 'Secret token',
	SETTINGS_REVISO_AGREEMENT_GRANT_TOKEN: 'Agreement grant token',

	DETAILS_SETTINGS_BILLING_FATTUREINCLOUD_SECTION: 'FattureInCloud',
	SETTINGS_BILLING_FATTUREINCLOUD_ACCESS_TOKEN: 'Access token',
	SETTINGS_BILLING_FATTUREINCLOUD_COMPANY_ID: 'ID azienda',
	// #endregion

	// #region Dashboard Links settings tab
	DIALOG_DASHBOARD_LINKS_TITLE: 'Collegamento Dashboard',
	DIALOG_COMMON_ICON: 'Icona',
	DIALOG_COMMON_URL: 'Url',

	DETAILS_SETTINGS_DASHBOARD_LINKS_SECTION: 'Collegamenti Dashboard',
	DETAILS_SETTINGS_DASHBOARD_LINKS_SUBHEADER: 'Impostazioni per collegamenti da visualizzare nella dashboard utente',
	DETAILS_SETTINGS_DASHBOARD_LINKS_VISIBILITY: 'Visibilità',
	DETAILS_SETTINGS_DASHBOARD_LINKS_VISIBILITY_ROLE: 'Ruolo Utente',
	DETAILS_SETTINGS_DASHBOARD_LINKS_VISIBILITY_GROUP: 'Gruppo',
	DETAILS_SETTINGS_DASHBOARD_LINKS_VISIBILITY_USER: 'Utente',
	// #endregion

	// #region JasperReports settings tab
	DETAILS_SETTINGS_REPORTS_JASPERREPORTS_SECTION: 'Impostazioni JasperReports',
	DETAILS_SETTINGS_REPORTS_JASPERREPORTS_SUBHEADER: "Impostazioni per l'integrazione con JasperReports",
	SETTINGS_REPORTS_JASPERREPORTS_STANDARD_ROOT_FOLDER: 'Percorso cartella report standard',
	SETTINGS_REPORTS_JASPERREPORTS_CUSTOM_ROOT_FOLDER: 'Percorso cartella report custom',
	SETTINGS_REPORTS_JASPERREPORTS_DATAADAPTER_PATH: 'Percorso data adapter',

	DETAILS_SETTINGS_REPORTS_JASPERREPORTS_JOBS_SECTION: 'Report schedulati da JasperReports',
	DETAILS_SETTINGS_REPORTS_JASPERREPORTS_JOBS_SUBHEADER: 'Lista di tutti i report schedulati da JasperReports',

	REPORTS_NEXT_EXECUTION: 'Prossima esecuzione:',
	// #endregion

	// #region Carbone settings section
	DETAILS_SETTINGS_REPORTS_CARBONE_SECTION: 'Carbone',
	DETAILS_SETTINGS_REPORTS_CARBONE_SUBHEADER: 'Impostazioni per la generatione dei documenti tramite Carbone',
	SETTINGS_REPORTS_CARBONE_REST_URL: 'URL Rest',

	DETAILS_SETTINGS_CARBONE_TEMPLATES_SECTION: 'Modelli',
	DETAILS_SETTINGS_CARBONE_TEMPLATES_SUBHEADER: 'Gestore modelli per Carbone',
	// #endregion

	// #region Closing Days settings section
	CLOSINGDAYS_TITLE: 'Descrizione',
	CLOSINGDAYS_DATE: 'Data',
	CLOSINGDAYS_RECURSIVE: 'Annuale',
	CLOSINGDAYS_CRON: 'Frequenza',
	CLOSINGDAYS_TABLE_TITLE: 'Giorni di chiusura',
	CLOSINGDAYS_TABLE_SUBTITLE_HOLIDAYS: "Giorni in cui l'azienda resterà chiusa per festività",
	CLOSINGDAYS_TABLE_SUBTITLE: "Giorni in cui l'azienda resterà chiusa per occasioni speciali, eventi o ferie",
	CLOSINGDAYS_HOLIDAYS_TITLE: 'Festività ricorrenti',
	DAYS: 'Giorno',
	WEEKS: 'Settimana',
	MONTHS: 'Mese',
	YEAR: 'Anno',
	CLOSINGDAYS_EVERY: 'Ogni',
	WEEKDAY_NOT_ENABLED: 'Giorno di chiusura'
	// #endregion
};

export default locale;
